import React, { useEffect, useState } from "react";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";
import { Link } from "react-router-dom";
import "../styles/style.css";
import Typography from "@mui/joy/Typography";
import { doc, db, getDoc, auth } from "../firebase";
import Footer from "../components/footer/footer";
import CircularProgressBar from "../components/progressbar/CircularProgressBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import PretestModal from "./pretestModal";
import PostTestModal from "./posttestModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  overflowY: "auto", // Allow vertical scrolling
  maxHeight: "80vh", // Set a maximum height
  p: 4,
};

function Progress() {
  let nbsp = "\u00a0";
  const [totalQuizzesDone, setTotalQuizzesDone] = useState(0);
  const [totalQuizzesDoneTS, setTotalQuizzesDoneTS] = useState(0);
  const [totalQuizzesDoneRS, setTotalQuizzesDoneRS] = useState(0);
  const [totalQuizzesDoneFPV, setTotalQuizzesDoneFPV] = useState(0);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [postTestModalOpen, setPostTestModalOpen] = useState(false);

  const handlePostTestModalOpen = () => setPostTestModalOpen(true);
  const handlePostTestModalClose = () => setPostTestModalOpen(false);

  const [overallPercentage, setOverallPercentage] = useState(0);
  const [overallPercentagePostTest, setOverallPercentagePostTest] = useState(0);
  const [topicAccuracies, setTopicAccuracies] = useState({
    safety: 0,
    fundamentals: 0,
    traffic: 0,
    fines: 0,
  });
  const [topicAccuraciesPostTest, setTopicAccuraciesPostTest] = useState({
    safety: 0,
    fundamentals: 0,
    traffic: 0,
    fines: 0,
  });

  const [pretestStatus, setPretestStatus] = useState(null);

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId);
      const statusDocRef = doc(userDocRef, "pretest", "status");

      const fetchPretestStatus = async () => {
        try {
          const docSnapshot = await getDoc(statusDocRef);
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const status = data.pretestStatus || null;
            setPretestStatus(status);
          } else {
            console.log(
              "Status document does not exist for user with ID:",
              userId
            );
          }
        } catch (error) {
          console.error("Error fetching pretest status:", error);
        }
      };

      fetchPretestStatus();
    }
  }, []);

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId);
      const overallDocRef = doc(userDocRef, "pretest", "overall");

      const fetchAccuracy = async (topic) => {
        const topicDocRef = doc(userDocRef, "pretest", topic);
        try {
          const docSnapshot = await getDoc(topicDocRef);
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const accuracy = data.accuracy || 0;
            setTopicAccuracies((prevAccuracies) => ({
              ...prevAccuracies,
              [topic]: accuracy,
            }));
          }
        } catch (error) {
          console.error(`Error fetching ${topic} accuracy:`, error);
        }
      };

      try {
        // Fetch totalQuizzesDone from Firestore
        getDoc(userDocRef).then((docSnapshot) => {
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const userTotalQuizzesDone = data.totalQuizzesDone || 0;
            const userTotalQuizzesDoneTS = data.totalQuizzesDoneTS || 0;
            const userTotalQuizzesDoneRS = data.totalQuizzesDoneRS || 0;
            const userTotalQuizzesDoneFPV = data.totalQuizzesDoneFPV || 0;

            const maxValue = 8;
            const maxValueTS = 7;
            const maxValueRS = 3;
            const maxValueFPV = 1;

            const rawPercentage = (userTotalQuizzesDone / maxValue) * 100;
            const rawPercentageTS = (userTotalQuizzesDoneTS / maxValueTS) * 100;
            const rawPercentageRS = (userTotalQuizzesDoneRS / maxValueRS) * 100;
            const rawPercentageFPV =
              (userTotalQuizzesDoneFPV / maxValueFPV) * 100;

            const roundedPercentage = Math.round(rawPercentage);
            const roundedPercentageTS = Math.round(rawPercentageTS);
            const roundedPercentageRS = Math.round(rawPercentageRS);
            const roundedPercentageFPV = Math.round(rawPercentageFPV);

            const convertedTotalQuizzesDone = Math.min(roundedPercentage, 100);
            const convertedTotalQuizzesDoneTS = Math.min(
              roundedPercentageTS,
              100
            );
            const convertedTotalQuizzesDoneRS = Math.min(
              roundedPercentageRS,
              100
            );
            const convertedTotalQuizzesDoneFPV = Math.min(
              roundedPercentageFPV,
              100
            );

            setTotalQuizzesDone(convertedTotalQuizzesDone);
            setTotalQuizzesDoneTS(convertedTotalQuizzesDoneTS);
            setTotalQuizzesDoneRS(convertedTotalQuizzesDoneRS);
            setTotalQuizzesDoneFPV(convertedTotalQuizzesDoneFPV);

            // Fetch accuracy for each topic
            fetchAccuracy("safety");
            fetchAccuracy("fundamentals");
            fetchAccuracy("traffic");
            fetchAccuracy("fines");
          } else {
            console.log("Document does not exist for user with ID:", userId);
          }
        });

        // Fetch overall data
        getDoc(overallDocRef).then((docSnapshot) => {
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const fetchedOverallPercentage = data.overallPercentage || 0;

            // Ensure that the percentage does not exceed 100
            const cappedOverallPercentage = Math.min(
              fetchedOverallPercentage,
              100
            );

            setOverallPercentage(cappedOverallPercentage);
          } else {
            console.log(
              "Overall document does not exist for user with ID:",
              userId
            );
          }
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
  }, []);

  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      const userId = user.uid;
      const userDocRef = doc(db, "users", userId);
      const overallDocRef = doc(userDocRef, "posttest", "overall");

      const fetchAccuracy = async (topic) => {
        const topicDocRef = doc(userDocRef, "posttest", topic);
        try {
          const docSnapshot = await getDoc(topicDocRef);
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const accuracy = data.accuracy || 0;
            setTopicAccuraciesPostTest((prevAccuracies) => ({
              ...prevAccuracies,
              [topic]: accuracy,
            }));
          }
        } catch (error) {
          console.error(`Error fetching ${topic} accuracy:`, error);
        }
      };

      try {
        fetchAccuracy("safety");
        fetchAccuracy("fundamentals");
        fetchAccuracy("traffic");
        fetchAccuracy("fines");
        // Fetch overall data
        getDoc(overallDocRef).then((docSnapshot) => {
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            const fetchedOverallPercentage = data.overallPercentage || 0;

            // Ensure that the percentage does not exceed 100
            const cappedOverallPercentagePostTest = Math.min(
              fetchedOverallPercentage,
              100
            );

            setOverallPercentagePostTest(cappedOverallPercentagePostTest);
          } else {
            console.log(
              "Overall document does not exist for user with ID:",
              userId
            );
          }
        });
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    }
  }, []);

  const isPostTestButtonEnabled =
    pretestStatus === true &&
    totalQuizzesDone === 100 &&
    totalQuizzesDoneTS === 100 &&
    totalQuizzesDoneRS === 100 &&
    totalQuizzesDoneFPV === 100;

  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="progress_page_wrapper">
        <div className="progress_wrapper">
          <div className="progress_overview">
            <h1>Progress Overview</h1>
            <div className="grid_wrapper">
              <div className="grid_item">
                <div className="grid_item_inner">
                  <div className="grid_title">
                    <h2>PRE-TEST</h2>
                    <div className="take_test_buttons">
                      <Link className="progress_test_button" to="/pretest">
                        Take Pre-Test
                      </Link>
                    </div>
                  </div>
                  <div className="test_checker">
                    <p>Score: {overallPercentage}%</p>{" "}
                  </div>
                </div>

                <h3>Recommendations:</h3>
                {topicAccuracies.fundamentals < 50 && (
                  <React.Fragment>
                    <h3>Fundamentals:</h3>
                    <p>{`Accuracy: ${topicAccuracies.fundamentals}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/fundamentals">
                        Fundamentals
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuracies.traffic < 50 && (
                  <React.Fragment>
                    <h3>Traffic:</h3>
                    <p>{`Accuracy: ${topicAccuracies.traffic}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/ts_rm_main">
                        Traffic Signs and Road Markings
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuracies.safety < 50 && (
                  <React.Fragment>
                    <h3>Safety:</h3>
                    <p>{`Accuracy: ${topicAccuracies.safety}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/road_safety_main">
                        Road Safety
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuracies.fines < 50 && (
                  <React.Fragment>
                    <h3>Fines:</h3>
                    <p>{`Accuracy: ${topicAccuracies.fines}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/fpv_main">
                        Fines, Penalties and Violations
                      </Link>
                    </p>
                  </React.Fragment>
                )}
              </div>
              <div className="grid_item">
                <div className="grid_item_inner">
                  <div className="grid_title">
                    <h2>POST-TEST</h2>
                    <div className="take_test_buttons">
                      {isPostTestButtonEnabled ? (
                        <Link
                          className="progress_test_button"
                          // onClick={handlePostTestModalOpen}
                          to="/posttest"
                        >
                          Take Post-Test
                        </Link>
                      ) : (
                        <span className="disabled_button progress_test_button">
                          Take Post-Test
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="test_checker">
                    <p>Score: {overallPercentagePostTest}%</p>{" "}
                  </div>
                </div>

                <h3>Recommendations</h3>
                {topicAccuraciesPostTest.fundamentals < 50 && (
                  <React.Fragment>
                    <h3>Fundamentals:</h3>
                    <p>{`Accuracy: ${topicAccuraciesPostTest.fundamentals}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/fundamentals">
                        Fundamentals
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuraciesPostTest.traffic < 50 && (
                  <React.Fragment>
                    <h3>Traffic:</h3>
                    <p>{`Accuracy: ${topicAccuraciesPostTest.traffic}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/ts_rm_main">
                        Traffic Signs and Road Markings
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuraciesPostTest.safety < 50 && (
                  <React.Fragment>
                    <h3>Safety:</h3>
                    <p>{`Accuracy: ${topicAccuraciesPostTest.safety}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/road_safety_main">
                        Road Safety
                      </Link>
                    </p>
                  </React.Fragment>
                )}

                {topicAccuraciesPostTest.fines < 50 && (
                  <React.Fragment>
                    <h3>Fines:</h3>
                    <p>{`Accuracy: ${topicAccuraciesPostTest.fines}%`}</p>
                    <p>
                      Please review{" "}
                      <Link className="cool-hyperlink" to="/fpv_main">
                        Fines, Penalties and Violations
                      </Link>
                    </p>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
          <div className="progress_detailed">
            <div className="progress_lessons">
              <h2>Fundamentals</h2>
              <CircularProgressBar percentage={totalQuizzesDone} />
            </div>
            <div className="progress_lessons">
              <h2>Traffic Signs and Road Markings</h2>
              <CircularProgressBar percentage={totalQuizzesDoneTS} />
            </div>
            <div className="progress_lessons">
              <h2>Road Safety</h2>
              <CircularProgressBar percentage={totalQuizzesDoneRS} />
            </div>
            <div className="progress_lessons">
              <h2>Fines, Penalties, Violation</h2>
              <CircularProgressBar percentage={totalQuizzesDoneFPV} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Progress;
